export interface CourseProgressStateLike {
  start_date?: string | null;
  completion_date?: string | null;
  time_accumulator?: number | null;
  score?: number | null;
  progress?: { sections?: unknown[] } | null;
}

export function hasCourseStarted(
  course: CourseProgressStateLike | null | undefined,
): boolean {
  const hasProgressSections = Array.isArray(course?.progress?.sections)
    ? course.progress.sections.length > 0
    : false;

  return Boolean(
    course?.start_date ||
    course?.completion_date ||
    (course?.time_accumulator || 0) > 0 ||
    hasProgressSections,
  );
}

export function hasDisplayableCourseScore(
  course: CourseProgressStateLike | null | undefined,
): boolean {
  return hasCourseStarted(course) && (course?.score || 0) > 0;
}
